/**
 * @file tooltip.tsx
 * @description Кастомный tooltip для диаграммы Ганта в Task Manager приложении. Отображает название задачи, даты начала и окончания с использованием иконки календаря и форматирования moment.js.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-19
 * @dependencies ['@consta/icons/IconCalendar', 'moment', 'react-dom/server']
 * @related-files ['src/components/ui/visualizations/charts/gantt/gantt.component.tsx']
 */

import { IconCalendar } from '@consta/icons/IconCalendar';
import moment from 'moment';
import { renderToStaticMarkup } from 'react-dom/server';
import type { Task } from '@src/types/gantt';

export const customTooltip = (task: Task): string => {
    return renderToStaticMarkup(
        <div className="flex flex-col gap-[0.8468vmin] text-[1.3761vmin] leading-[150%]">
            <span className="font-semibold">{task.$item?.name}</span>
            <hr className="border-[#F6FBFD4D]" />
            <div className="flex gap-[0.5293vmin] items-center">
                <IconCalendar size="xs" className="h-[1.693vmin] aspect-square" />
                <span>{moment(task.start_date).format('dd DD.MM.YY')}</span>
                <span>-</span>
                <span>{moment(task.end_date).format('dd DD.MM.YY')}</span>
            </div>
        </div>
    );
};
